import { render, staticRenderFns } from "./WaterProduct.vue?vue&type=template&id=e15a8a62&"
import script from "./WaterProduct.vue?vue&type=script&lang=js&"
export * from "./WaterProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports